import React from 'react';
import { Points } from 'components/Points/Points';
import './TradesSummary.css';

interface SummaryStats {
  ready: number;
  transit: number;
  completed: number;
  cancelled: number;
  totalPoints: number;
}

interface Props {
  stats: SummaryStats;
}

export default function TradesSummary({ stats }: Props) {
  return (
    <div className="trades-summary">
      <div className="summary-card">
        <div className="summary-number">{stats.ready}</div>
        <div className="summary-label">Ready to ship</div>
      </div>
      
      <div className="summary-card">
        <div className="summary-number">{stats.transit}</div>
        <div className="summary-label">In Transit</div>
      </div>
      
      <div className="summary-card">
        <div className="summary-number">{stats.completed}</div>
        <div className="summary-label">Completed</div>
      </div>

      <div className="summary-card">
        <div className="summary-number">{stats.cancelled}</div>
        <div className="summary-label">Cancelled</div>
      </div>

      <div className="summary-card points-card">
        <Points points={stats.totalPoints} type="big" />
        <div className="summary-label">Outbound trades</div>
      </div>
    </div>
  );
}